import { putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const UPDATE_APPOINTMENTS = 'UPDATE_APPOINTMENTS';
export const UPDATE_APPOINTMENTS_SUCCESS = 'UPDATE_APPOINTMENTS_SUCCESS';
export const UPDATE_APPOINTMENTS_FAILURE = 'UPDATE_APPOINTMENTS_FAILURE';

// Action Creators
export const fetchUpdateAppointments = () => ({
  type: UPDATE_APPOINTMENTS,
});

export const fetchUpdateAppointmentsSuccess = (data) => ({
  type: UPDATE_APPOINTMENTS_SUCCESS,
  payload: data,
});

export const fetchUpdateAppointmentsFailure = (error) => ({
  type: UPDATE_APPOINTMENTS_FAILURE,
  payload: error,
});

// Thunk Function
export const updateAppointmentsCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchUpdateAppointments(data, external));
    try {
      const response = await putMethodWithToken(
        url.updateAppointmentsListProviderAdmin +
          external?.id +
          '/' +
          'update' +
          '/',
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchUpdateAppointmentsSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchUpdateAppointmentsFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchUpdateAppointmentsFailure(error.message));
    }
  };
};
